import { useQuery } from '@tanstack/react-query';

import { listQueryOptions } from '@/lib/query-client';
import { makeQueryKeys } from '@/lib/query-keys';

import { clientsService } from '../services';
import type { ClientListParams } from '../types';

export const clientsKeys = makeQueryKeys('clients');

export function useClients(params: ClientListParams = {}) {
  return useQuery({
    queryKey: clientsKeys.list(params),
    queryFn: () => clientsService.list(params),
    ...listQueryOptions,
  });
}
